module.exports = __webpack_public_path__ + "static/media/julia.87dc2da9.svg";